import { useEffect, useState } from "react";

import type { PartnerProgram } from "../customer-info/useCustomerProgram";

import { type CalcIsConfirmationDisabledResult, calcIsConfirmationDisabled } from "../utils/calcIsConfirmationDisabled";
import { useMdnLookupResult } from "./useMdnLookupResult";

interface UseIsConfirmationDisabledParams {
    additionalDetailsFormIsValid: boolean;
    customerName: string | undefined;
    customerProgram: PartnerProgram | undefined;
    isEditingVerificationInput: boolean;
    mdn: string;
    sessionId: string;
    showProgramSelection: boolean | undefined;
    shouldSkipMdnValidation: boolean | undefined;
    verificationFormIsValid: boolean;
    verificationType: "phoneNumber" | "billingAccountNumberAndPin";
}

export const useIsConfirmationDisabled = ({
    additionalDetailsFormIsValid,
    customerName,
    customerProgram,
    isEditingVerificationInput,
    mdn,
    sessionId,
    showProgramSelection,
    shouldSkipMdnValidation,
    verificationFormIsValid,
    verificationType,
}: UseIsConfirmationDisabledParams) => {
    const [result, setResult] = useState<CalcIsConfirmationDisabledResult>({
        isConfirmationDisabled: false,
    });
    const mdnLookupResult = useMdnLookupResult(sessionId);

    useEffect(() => {
        const checkConfirmationDisabled = async () => {
            const result = await calcIsConfirmationDisabled({
                customerName,
                verificationType,
                mdn,
                verificationFormIsValid,
                additionalDetailsFormIsValid,
                isEditingVerificationInput,
                showProgramSelection,
                customerProgram,
                mdnLookupResult,
                shouldSkipMdnValidation: !!shouldSkipMdnValidation,
            });

            setResult(result);
        };

        void checkConfirmationDisabled();
    }, [
        additionalDetailsFormIsValid,
        customerName,
        customerProgram,
        isEditingVerificationInput,
        mdn,
        mdnLookupResult,
        showProgramSelection,
        shouldSkipMdnValidation,
        verificationFormIsValid,
        verificationType,
    ]);

    return result;
};
